const unauthorizedNav = [
    'home',
    'wizard'
];

const webMasterNav = [
    'home',
    'wizard'
];

const touroperatorNav = [
    'home',
    'wizard',
    'claims',
    'reports',
    'messages',
    //'postpone'
];

const clientNav = [
    'home',
    'wizard',
    'myClaims'
];

export {unauthorizedNav, webMasterNav, touroperatorNav, clientNav};
